// extracted by mini-css-extract-plugin
export default {"image_box":"style_image_box__WU5It"};